import { instance } from '@/libs/api/instance'

/**
 * Get available card order options.
 * If walletUuid is provided, options are based on that wallet's card provider.
 *
 * @param {string} [walletUuid]
 * @return {Promise<AxiosResponse<any>>}
 */
export const getDeliveryInfo = (walletUuid) => {
  return instance.get('/v1/card/info', {
    params: walletUuid ? { walletId: walletUuid } : undefined,
  })
}
